import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type ModalTitleProps = {
  className?: string;
} & PropsWithChildren;

export const ModalTitle: FC<ModalTitleProps> = ({ children, className }) => {
  return <h1 className={twMerge('font-semibold text-primary-900', className)}>{children}</h1>;
};
